<template>
  <div
    class="portfolio-element"
    :class="portfolio.id === 2 || portfolio.id === 4 ? 'mirror-render' : ''"
  >
    <div class="video-section">
      <div class="video-section-phone">
        <img src="../assets/img/iphone-back.svg" alt class="iphone-back" />
        <video  class="portfolio-video"
                :class="portfolio.id === 2 || portfolio.id === 4 ? 'mirror-render' : ''" autoplay muted loop>
          <source :src="portfolio.video" type="video/mp4" />
        </video>
      </div>
      <div class="video-section-circle" :id="`circle${portfolio.id}`" :style="portfolio.color"></div>
    </div>
    <div
      class="portfolio-text-mob-section"
      :class="portfolio.id === 4 || portfolio.id === 2 ? 'mirror-render mirror-render-right' : ''"
    >
      <img :class="classById(portfolio.id)" :src="portfolio.logo" alt="portfolio-logo" />
      <div class="portfolio-small-header">{{ $t(portfolio.smallHeader) }}</div>
      <div class="video-section-hidden">
        <div class="video-section-phone">
          <img src="../assets/img/iphone-back.svg" alt class="iphone-back" />
          <video class="portfolio-video"
                :class="portfolio.id === 2 || portfolio.id === 4 ? 'mirror-render' : ''" autoplay muted loop playsinline>
            <source :src="portfolio.video" type="video/mp4" />
          </video>
        </div>
        <div class="video-section-circle" :id="`figure${portfolio.id}`" :style="portfolio.color"></div>
      </div>
      <div class="portfolio-main-text" :class="portfolio.id === 4 ? 'forth-child-text' : ''">
        <span>{{ $t(portfolio.mainText) }}</span>
      </div>
      <ul class="list-of-description">
        <li v-for="item in portfolio.list" :key="item.name" class="portfolio-list-item">
          <span class="portfolio-big-header">{{ $t(item.name) }}</span>
          <ul class="portfolio-text" v-if="item.id === 'team'">
            <li v-for="item in item.text" :key="item">{{ $t(item) }}</li>
          </ul>
          <span class="portfolio-text" v-else>{{ $t(item.text) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "portfolio-element",
  props: {
    portfolio: { type: Object, default: null },
    width: { type: Number, default: null }
  },
  methods: {
    classById(id) {
      switch (id) {
        case 1:
          return "megazone-logo";
        case 2:
          return "fc-logo";
        case 3:
          return "ilich-logo";
        case 4:
          return "pay-logo";
      }
    },
    prossedAnimation() {
      const trigger = this.width >= 768 ? "circle" : "figure";
      Array(4)
        .fill(0)
        .forEach((item, i) => {
          i++;
          const scene = this.$scrollmagic
            .scene({
              triggerElement: `#${trigger}${i}`,
              reverse: false
            })
            .setClassToggle(`#${trigger}${i}`, "boom");
          this.$scrollmagic.addScene(scene);
        });
    }
  },
  watch: {
    width: function() {
      this.prossedAnimation();
    }
  },
  mounted() {
    this.prossedAnimation();
  }
};
</script>

<style scoped lang="scss">
.portfolio-element {
  display: flex;
  width: 1033px;
  margin: 0 auto 159px;

  @media screen and (max-width: 1130px) {
    margin: 0 50px 150px 50px;
    width: initial;
  }

  @media screen and (max-width: 1012px) {
    margin: 0 50px 100px 50px;
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 56px;
    display: flex;
    justify-content: center;
  }

  @media screen and (max-width: 479px) {
    margin: 0 20px 46px;
  }

  &:nth-child(6) {
    margin-bottom: 100px;
    @media screen and (max-width: 1130px) {
      margin-bottom: 80px;
    }

    @media screen and (max-width: 1012px) {
      margin-bottom: 70px;
    }

    @media screen and (max-width: 767px) {
      margin-bottom: 30px;
    }

    // @media screen and (max-width: 479px) {
    //   margin-bottom: 0;
    // }
  }
}


.video-section-circle {
  width: 488px;
  height: 488px;
  // background: linear-gradient(180deg, #379ae1 0%, #37cde1 100%);
  opacity: 0.5;
  border-radius: 555px;
  transform: scale(0);

  @media screen and (max-width: 1012px) {
    top: -100px;
    right: 0px;
    left: -200px;
  }
}

.boom {
  animation: boom 0.5s forwards;
}

.iphone-back {
  position: absolute;
  left: -13%;
  top: -4%;

  @media screen and (max-width: 1130px) {
    width: 123%;
  }
}

.video-section {
  position: relative;
  display: flex;
  width: 40%;

  @media screen and (max-width: 1130px) {
    justify-content: center;
  }

  @media screen and (max-width: 1012px) {
    margin-right: 41px;
  }

  @media screen and (max-width: 767px) {
    display: none;
  }
}

.video-section-hidden {
  display: none;

  @media screen and (max-width: 767px) {
    display: flex;
    position: relative;
  }
}

.description-logo-img {
  &:only-of-type {
    width: 132px;
  }

  &:nth-of-type(2) {
    width: 232px;
  }
}

.portfolio-text-mob-section {
  @media screen and (min-width: 768px) {
    margin-top: 17px;
  }

   @media screen and (width: 768px) {
    margin-top: 12px;
  }
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.video-section-phone {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  width: 331px;
  height: 670px;
  //
  border-radius: 25px;
  background-size: contain;
  // background-repeat: round;
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
  // box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.2);

  @media screen and (max-width: 1130px) {
    background-size: 280px 566px;
    width: 280px;
    height: 566px;
  }

  @media screen and (max-width: 1012px) {
    background-size: 233px 472px;
    width: 233px;
    height: 472px;
  }

  @media screen and (max-width: 767px) {
    width: 225px;
    height: 455.44px;
    background-position: initial;
    //  background: url("../assets/img/iphone-back.svg");
  }

  video {
    position: relative;
    left: -24px;
    top: -3px;
    width: 90%;

    @media screen and (max-width: 1130px) {
      top: 19px;
      width: 256px;
      height: 535px;
      left: -15px;
    }

    @media screen and (max-width: 1012px) {
      width: 209px;
      height: 438px;
      left: -15px;
    }

    @media screen and (max-width: 767px) {
      width: 205.29px;
      height: 420.93px;
      top: 21px;
      left: -12px;


    }


  }
}

.video-section-circle {
  position: absolute;
  bottom: 42%;
  right: 42%;

  @media screen and (max-width: 1130px) {
    width: 400px;
    height: 400px;
    bottom: 56%;
  }

  @media screen and (max-width: 767px) {
    width: 335px;
    height: 335px;
    top: 12%;
    left: -25%;
  }

  @media screen and (max-width: 479px) {
    width: 148%;
    height: 70%;
  }

  @media screen and (max-width: 374px) {
    width: 280px;
    height: 280px;
    left: -14%;
  }
}



/// keyframes///

@keyframes boom {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

/// keyframes///

.portfolio-small-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  margin: 10px 0 10px 0;

  @media screen and (max-width: 767px) {
    margin: 8px 0 30px 0;
  }

  @media screen and (max-width: 479px) {
    margin-bottom: 30px;
  }
}

.forth-child-text {
  width: 80%;
  position: relative;
  left: 20%;
  @media screen and (max-width: 1130px) {
      width: 96%;
      left: 0%;
  }

  @media screen and (max-width: 1012px) {
      width: 396px !important;
  }

  @media screen and (max-width: 767px) {
    width: initial !important;
  }
}

.portfolio-main-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  color: #000000;
  opacity: 0.5;
  max-width: 616px;
  margin-bottom: 20px;

  @media screen and (max-width: 1130px) {
    max-width: 500px;
    &:nth-of-type(2) {
      width: 96%;
      left: 0%;
    }
  }

  @media screen and (max-width: 1012px) {
    width: initial;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
    &:nth-of-type(2) {
      width: 396px;
    }
  }

  @media screen and (max-width: 767px) {
    margin-top: 40px;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    margin-bottom: 15px;
  }

  @media screen and (max-width: 479px) {
    margin-top: 30px;
    margin-bottom: 15px;
  }
}

.list-of-description {
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.portfolio-list-item {
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 767px) {
    text-align: center;
  }
}

.portfolio-big-header {
  font-family: Roboto;
  font-style: normal;
  font-size: 20px;
  line-height: 23px;
  margin-bottom: 4px;
  color: #000000;

  @media screen and (max-width: 767px) {
    margin-bottom: 0;
  }
}

.portfolio-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  /* identical to box height, or 22px */
  @media screen and (max-width: 1012px) {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
  }

  @media screen and (max-width: 767px) {
    font-size: 16px;
    margin-bottom: 15px;
    line-height: 23px;
  }

  @media screen and (max-width: 479px) {
    margin-bottom: 15px;
  }


  color: #000000;

  opacity: 0.5;
  margin-bottom: 20px;
}

.mirror-render {
  transform: scale(-1, 1);
  text-align: right;
}

.portfolio-video.mirror-render {
  @media screen and (max-width: 767px) {
     transform: scale(1, 1);
  }
}

.mirror-render-right {
  @media screen and (max-width: 1130px) {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
  }

  @media screen and (max-width: 767px) {
    align-items: center;
  }
}

@media screen and (max-width: 767px) {
  .megazone-logo {
    width: 232px;
    height: 60px;
  }

  .fc-logo {
    width: 134px;
    height: 81px;
  }

  .ilich-logo {
    width: 334px;
    height: 62px;

    @media screen and (max-width: 374px) {
      width: 280px;
    }
  }

  .pay-logo {
    width: 262.21px;
    height: 44.06px;
  }
}
</style>
